import { FC } from 'react';
import * as React from 'react';

import { useTheme } from '@mui/material/styles';

interface Shortcut {
  name: string;
  keys: string[];
}

interface ShortcutCategory {
  category: string;
  shortcuts: Shortcut[];
}

export const KeyboardShortcutsPanel: FC = () => {
  const theme = useTheme();

  const shortcutCategories: ShortcutCategory[] = [
    {
      category: 'General',
      shortcuts: [
        { name: 'Command line', keys: ['Ctrl', '/'] },
        { name: 'Previous CFS', keys: ['Ctrl', '<'] },
        { name: 'Next CFS', keys: ['Ctrl', '>'] },
        { name: 'Collapse or Expand the sidebar', keys: ['Ctrl', '['] },
      ],
    },
  ];

  const renderShortcutKeys = (keys: string[]) => {
    return (
      <div className="flex flex-row items-center gap-3">
        {keys.map((key, index) => (
          <React.Fragment key={index}>
            <div
              className="w-9 h-6 flex items-center justify-center rounded-md font-medium text-[0.813rem] shadow-sm"
              style={{
                backgroundColor:
                  theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.08)'
                    : '#E7EAEC66',
                color: '#3E5A6A',
                borderBottom: `1px solid ${
                  theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.12)'
                    : 'rgba(0, 0, 0, 0.12)'
                }`,
                boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
                fontFamily: 'Roboto',
              }}
            >
              {key}
            </div>
            {index < keys.length - 1 &&
              key !== '+' &&
              keys[index + 1] !== '+' && (
                <span
                  className="text-sm font-normal"
                  style={{ color: '#3E5A6A' }}
                >
                  +
                </span>
              )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div className="grid grid-cols-2 gap-4 !w-full">
      {/* First div - Shortcuts with justify-between */}
      <div className="flex-1 overflow-auto">
        {shortcutCategories.map((category, categoryIndex) => (
          <div key={categoryIndex}>
            {/* Category Header */}
            <div className="px-3 py-1.5">
              <h3 className="text-sm font-semibold">{category.category}</h3>
            </div>

            {/* Shortcuts List */}
            {category.shortcuts.map((shortcut, index) => (
              <div
                key={index}
                className="flex flex-row items-center justify-between px-3 py-1.5"
                style={{
                  borderBottom:
                    index < category.shortcuts.length - 1
                      ? `1px solid ${theme.palette.divider}`
                      : 'none',
                }}
              >
                <span
                  className="text-sm font-normal"
                  style={{ color: theme.palette.text.secondary }}
                >
                  {shortcut.name}
                </span>
                <span>{renderShortcutKeys(shortcut.keys)}</span>
              </div>
            ))}

            {/* Add spacing between categories except for the last one */}
            {categoryIndex < shortcutCategories.length - 1 && (
              <div className="h-6" />
            )}
          </div>
        ))}
      </div>

      {/* Second div - Empty */}
      <div></div>
    </div>
  );
};
